import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "ws" }
const _hoisted_2 = { class: "ws__header" }
const _hoisted_3 = { class: "ws__header-right" }
const _hoisted_4 = { class: "ws__main" }
const _hoisted_5 = { class: "ws__card ws__card--left" }
const _hoisted_6 = { class: "ws__dropzone-title" }
const _hoisted_7 = {
  key: 0,
  class: "ws__files"
}
const _hoisted_8 = { class: "ws__file-name" }
const _hoisted_9 = { class: "ws__file-size" }
const _hoisted_10 = { class: "ws__file-actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "ws__preflight-loading"
}
const _hoisted_15 = {
  key: 2,
  class: "ws__preflight"
}
const _hoisted_16 = { class: "ws__preflight-stat" }
const _hoisted_17 = { class: "ws__preflight-stat" }
const _hoisted_18 = { class: "ws__preflight-stat" }
const _hoisted_19 = { class: "ws__preflight-stat" }
const _hoisted_20 = {
  key: 3,
  class: "ws__error"
}
const _hoisted_21 = { class: "ws__actions" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 4,
  class: "ws__cost-note"
}
const _hoisted_24 = { class: "ws__quota-modal" }
const _hoisted_25 = { class: "ws__quota-balance" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 1,
  class: "ws__quota-msg"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 2,
  class: "ws__quota-msg"
}
const _hoisted_32 = { class: "ws__quota-modal" }
const _hoisted_33 = {
  key: 0,
  class: "ws__quota-msg"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "ws__quota-modal" }
const _hoisted_36 = { class: "ws__quota-rule" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 1,
  class: "ws__quota-msg"
}
const _hoisted_40 = {
  key: 2,
  class: "ws__quota-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskCenter = _resolveComponent("TaskCenter")!
  const _component_AuthModal = _resolveComponent("AuthModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("h1", { class: "ws__title" }, [
        _createElementVNode("img", {
          src: "/4.png",
          alt: "图转可编辑 PPT"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.store.session)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                type: "button",
                class: "ws__balance",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.showQuotaModal()))
              }, _toDisplayString(_ctx.store.profile?.points ?? 0) + " 额度", 1),
              (_ctx.store.profile?.is_admin)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "ws__link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/admin')))
                  }, "管理后台"))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "ws__link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordModalVisible = true))
              }, "修改密码"),
              _createElementVNode("button", {
                type: "button",
                class: "ws__link",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.store.logout()))
              }, "退出登录")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("button", {
                type: "button",
                class: "ws__redeem-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.store.showCouponModal()))
              }, "兑换码"),
              _createElementVNode("button", {
                type: "button",
                class: "ws__login-btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.store.showAuthModal()))
              }, "登录")
            ], 64))
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "ws__card-head" }, [
          _createElementVNode("span", { class: "ws__card-label" }, "新任务"),
          _createElementVNode("span", { class: "ws__model-tag" }, "当前模型:ChatGPT-5.6-sol"),
          _createElementVNode("span", { class: "ws__card-hint" }, "最多 20 页 · 单文件 20 MB")
        ], -1)),
        (!_ctx.store.session)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["ws__dropzone", { 'ws__dropzone--drag': _ctx.isDragging }]),
              onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
              onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.isDragging = false), ["prevent"])),
              onDrop: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.store.showAuthModal()))
            }, [...(_cache[38] || (_cache[38] = [
              _createElementVNode("p", { class: "ws__dropzone-title" }, "登录后上传图片或 PDF", -1),
              _createElementVNode("p", { class: "ws__dropzone-sub" }, "支持 PNG、JPG、WebP 和多页 PDF；点击或拖入文件后登录", -1)
            ]))], 34))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: _normalizeClass(["ws__dropzone", { 'ws__dropzone--drag': _ctx.isDragging, 'ws__dropzone--disabled': _ctx.store.uploading }]),
                onDragover: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.isDragging = true), ["prevent"])),
                onDragleave: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.isDragging = false), ["prevent"])),
                onDrop: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (!_ctx.store.uploading && _ctx.triggerFileInput()))
              }, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.store.uploading ? '正在上传...' : '选择图片或 PDF'), 1),
                _cache[39] || (_cache[39] = _createElementVNode("p", { class: "ws__dropzone-sub" }, "支持 PNG、JPG、WebP 和多页 PDF；将按文件顺序合成", -1)),
                _createElementVNode("input", {
                  ref: "fileInput",
                  type: "file",
                  multiple: "",
                  accept: "image/png,image/jpeg,image/webp,application/pdf",
                  class: "ws__file-input",
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
                }, null, 544)
              ], 34),
              (_ctx.store.stagedFiles.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.stagedFiles, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "ws__file"
                      }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(file.name), 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatSize(file.size)), 1),
                        _createElementVNode("div", _hoisted_10, [
                          (_ctx.store.stagedFiles.length > 1 && index > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "ws__file-btn",
                                onClick: ($event: any) => (_ctx.store.reorderFile(index, index - 1))
                              }, "↑", 8, _hoisted_11))
                            : _createCommentVNode("", true),
                          (_ctx.store.stagedFiles.length > 1 && index < _ctx.store.stagedFiles.length - 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "ws__file-btn",
                                onClick: ($event: any) => (_ctx.store.reorderFile(index, index + 1))
                              }, "↓", 8, _hoisted_12))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ws__file-btn ws__file-btn--remove",
                            onClick: ($event: any) => (_ctx.store.removeFile(index))
                          }, "×", 8, _hoisted_13)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.store.preflightLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "正在计算页数和价格..."))
                : (_ctx.store.preflightResult)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.store.preflightResult.totalPages), 1),
                        _cache[40] || (_cache[40] = _createElementVNode("span", null, "总页数", -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.store.preflightResult.costPoints), 1),
                        _cache[41] || (_cache[41] = _createElementVNode("span", null, "额度", -1))
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("strong", null, "¥" + _toDisplayString((_ctx.store.preflightResult.costPoints * 1.9).toFixed(1)), 1),
                        _cache[42] || (_cache[42] = _createElementVNode("span", null, "等值", -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("strong", null, "~" + _toDisplayString(Math.ceil(_ctx.store.preflightResult.totalPages * 15)) + "分", 1),
                        _cache[43] || (_cache[43] = _createElementVNode("span", null, "预计", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.store.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.store.error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ws__btn ws__btn--primary",
                  disabled: !_ctx.store.preflightResult || _ctx.store.preflightLoading || _ctx.store.submitting || (_ctx.store.profile?.points ?? 0) < (_ctx.store.preflightResult?.costPoints ?? 0),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.store.submitTask()))
                }, _toDisplayString(_ctx.store.submitting ? '提交中...' : '确认并开始转换'), 9, _hoisted_22)
              ]),
              (_ctx.store.preflightResult)
                ? (_openBlock(), _createElementBlock("p", _hoisted_23, "每页 1 额度（1.9 元）。失败或超时的页面自动返还额度；产物最多保留 30 天，源文件下载链接 24 小时内、成品 7 天内有效。"))
                : _createCommentVNode("", true),
              (_ctx.store.preflightResult && (_ctx.store.profile?.points ?? 0) < _ctx.store.preflightResult.costPoints)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    type: "button",
                    class: "ws__insufficient",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.store.showQuotaModal()))
                  }, "额度不足，点击兑换码或联系管理员"))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _createVNode(_component_TaskCenter, { class: "ws__card ws__card--right" })
    ]),
    (_ctx.store.authModalVisible)
      ? (_openBlock(), _createBlock(_component_AuthModal, {
          key: 0,
          "on-success": _ctx.store.onAuthSuccess,
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.store.hideAuthModal()))
        }, null, 8, ["on-success"]))
      : _createCommentVNode("", true),
    (_ctx.store.quotaModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "ws__quota-overlay",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "额度",
          onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.store.hideQuotaModal()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_24, [
            _cache[47] || (_cache[47] = _createElementVNode("h3", { class: "ws__quota-title" }, "额度", -1)),
            _createElementVNode("p", _hoisted_25, [
              _cache[45] || (_cache[45] = _createTextVNode("当前额度：", -1)),
              _createElementVNode("strong", null, _toDisplayString(_ctx.store.profile?.points ?? 0), 1)
            ]),
            _cache[48] || (_cache[48] = _createElementVNode("p", { class: "ws__quota-rule" }, "1 额度 = 1 页 · ¥1.90/页", -1)),
            (_ctx.alipayEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[46] || (_cache[46] = _createElementVNode("label", {
                    class: "sr-only",
                    for: "alipay-points"
                  }, "购买额度", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "alipay-points",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.store.alipayPoints) = $event)),
                    type: "number",
                    min: "1",
                    max: "10000",
                    step: "1",
                    class: "ws__quota-input",
                    placeholder: "输入购买额度",
                    disabled: _ctx.store.alipayPaying
                  }, null, 8, _hoisted_26), [
                    [
                      _vModelText,
                      _ctx.store.alipayPoints,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ws__btn ws__btn--primary ws__quota-btn",
                    disabled: _ctx.store.alipayPaying,
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.store.buyPointsWithAlipay()))
                  }, _toDisplayString(_ctx.store.alipayPaying ? '正在创建订单...' : '支付宝购买额度'), 9, _hoisted_27)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.store.redeemMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.store.redeemMessage), 1))
              : _createCommentVNode("", true),
            _cache[49] || (_cache[49] = _createElementVNode("label", {
              class: "sr-only",
              for: "quota-invite"
            }, "兑换码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "quota-invite",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.store.inviteCode) = $event)),
              class: "ws__quota-input",
              placeholder: "输入兑换码",
              disabled: _ctx.store.redeeming,
              onKeyup: _cache[21] || (_cache[21] = _withKeys(($event: any) => (_ctx.store.doRedeem()), ["enter"]))
            }, null, 40, _hoisted_29), [
              [_vModelText, _ctx.store.inviteCode]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ws__btn ws__btn--primary ws__quota-btn",
              disabled: _ctx.store.redeeming || !_ctx.store.inviteCode.trim(),
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.store.doRedeem()))
            }, _toDisplayString(_ctx.store.redeeming ? '兑换中...' : '兑换额度'), 9, _hoisted_30),
            (_ctx.store.redeemMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.store.redeemMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ws__btn ws__btn--ghost ws__quota-close",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.store.hideQuotaModal()))
            }, "关闭")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.passwordModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "ws__quota-overlay",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "修改密码",
          onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.passwordModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_32, [
            _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "ws__quota-title" }, "修改密码", -1)),
            _cache[51] || (_cache[51] = _createElementVNode("label", {
              class: "sr-only",
              for: "pwd-old"
            }, "旧密码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "pwd-old",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.oldPassword) = $event)),
              type: "password",
              class: "ws__quota-input",
              placeholder: "旧密码",
              autocomplete: "current-password"
            }, null, 512), [
              [_vModelText, _ctx.oldPassword]
            ]),
            _cache[52] || (_cache[52] = _createElementVNode("label", {
              class: "sr-only",
              for: "pwd-new"
            }, "新密码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "pwd-new",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: "password",
              class: "ws__quota-input",
              placeholder: "新密码（至少 8 位）",
              autocomplete: "new-password"
            }, null, 512), [
              [_vModelText, _ctx.newPassword]
            ]),
            _cache[53] || (_cache[53] = _createElementVNode("label", {
              class: "sr-only",
              for: "pwd-confirm"
            }, "确认新密码", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "pwd-confirm",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: "password",
              class: "ws__quota-input",
              placeholder: "确认新密码",
              autocomplete: "new-password",
              onKeyup: _cache[28] || (_cache[28] = _withKeys(($event: any) => (_ctx.submitPasswordChange()), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.confirmPassword]
            ]),
            (_ctx.passwordMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.passwordMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ws__btn ws__btn--primary ws__quota-btn",
              disabled: _ctx.passwordSubmitting,
              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.submitPasswordChange()))
            }, _toDisplayString(_ctx.passwordSubmitting ? '提交中...' : '确认修改'), 9, _hoisted_34),
            _createElementVNode("button", {
              type: "button",
              class: "ws__btn ws__btn--ghost ws__quota-close",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.passwordModalVisible = false))
            }, "关闭")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.store.couponModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "ws__quota-overlay",
          role: "dialog",
          "aria-modal": "true",
          "aria-label": "兑换码",
          onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.store.hideCouponModal()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_35, [
            _cache[55] || (_cache[55] = _createElementVNode("h3", { class: "ws__quota-title" }, "兑换额度", -1)),
            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.store.couponRedeemSucceeded ? '兑换已完成，额度已更新' : _ctx.store.couponAutoRedeeming ? '登录成功，正在自动兑换额度' : _ctx.store.session ? '输入兑换码后立即兑换为额度' : '输入兑换码，注册或登录后自动兑换'), 1),
            (!_ctx.store.couponAutoRedeeming && !_ctx.store.couponRedeemSucceeded)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[54] || (_cache[54] = _createElementVNode("label", {
                    class: "sr-only",
                    for: "coupon-code"
                  }, "兑换码", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "coupon-code",
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.store.couponCode) = $event)),
                    class: "ws__quota-input",
                    placeholder: "输入兑换码",
                    disabled: _ctx.store.redeeming,
                    onKeyup: _cache[33] || (_cache[33] = _withKeys(($event: any) => (_ctx.store.requestCouponRedeem()), ["enter"]))
                  }, null, 40, _hoisted_37), [
                    [_vModelText, _ctx.store.couponCode]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ws__btn ws__btn--primary ws__quota-btn",
                    disabled: _ctx.store.redeeming || !_ctx.store.couponCode.trim(),
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.store.requestCouponRedeem()))
                  }, _toDisplayString(_ctx.store.redeeming ? '兑换中...' : '确认兑换'), 9, _hoisted_38)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.store.couponAutoRedeeming)
              ? (_openBlock(), _createElementBlock("p", _hoisted_39, "正在兑换..."))
              : _createCommentVNode("", true),
            (_ctx.store.couponRedeemResult)
              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.store.couponRedeemResult), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ws__btn ws__btn--ghost ws__quota-close",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.store.hideCouponModal()))
            }, "关闭")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}